import * as Scrivito from "scrivito";

Scrivito.provideComponent("TextWidget", ({ widget }) => {
  const classNames = ["text-widget"];
  if (widget.get("alignment")) {
    classNames.push(
      `text-${
        widget.get("alignment") === "right" ? "end" : widget.get("alignment")
      }`
    );
  }

  return (
    <Scrivito.ContentTag
      tag="div"
      className={classNames.join(" ")}
      content={widget}
      attribute="text"
    />
  );
});
